export default {
  getCardBrand (PagSeguroDirectPayment, { number }) {
    return new Promise((resolve, reject) => {
      PagSeguroDirectPayment.getBrand({
        cardBin: number,
        success: response => {
          resolve(response.brand.name)
        },
        error: response => reject(response)
      })
    })
  },
  getSenderHash (PagSeguroDirectPayment) {
    return new Promise((resolve, reject) => {
      PagSeguroDirectPayment.onSenderHashReady(response => {
        if (response.status === 'error') {
          return reject(response)
        }
        resolve(response.senderHash)
      })
    })
  },
  createCardToken (PagSeguroDirectPayment, { brand, cvv, number, month, year }) {
    return new Promise((resolve, reject) => {
      PagSeguroDirectPayment.createCardToken({
        cardNumber: number,
        cvv,
        expirationMonth: month,
        expirationYear: year,
        success: response => resolve(response.card.token),
        error: response => reject(response)
      })
    })
  }
}
